import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const PERSONNE_ROUTES = CONF?.ROUTES?.PERSONNE
const CONTRAT_ROUTES = CONF?.ROUTES?.CONTRAT
const INFINITE_ROUTES = CONF?.ROUTES?.INFINITE

export const postChangementContrat = async (form) => {

    console.log("form")
    console.log(form)

    console.log("CONF?.ROUTES?.FORMULAIRES?.ENVOI_FORMULAIRE")
    console.log(CONF?.ROUTES?.FORMULAIRES?.ENVOI_FORMULAIRE)

    try {
        const resp = await axiosCoralie.post(CONF?.ROUTES?.FORMULAIRES?.ENVOI_FORMULAIRE, form)

        console.log("postChangementContrat : ", resp)
        console.log(resp)

        return resp

    } catch (err) {
        throw err;
    }
}